import React from 'react';
import {connect} from 'react-redux';
import AuthContainer from './AuthContainer';
import Notifier from './simple/notifier';
import WrongPage from './pages/WrongPage';
import {cloneDeep} from 'lodash';

class MainContainer extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {wrongPage} = this.props;
        return (
            wrongPage
                ? <WrongPage />
                : <React.Fragment>
                    <Notifier />
                    <AuthContainer />
                </React.Fragment>
        )
    };
}

function mapStateToProps(state) {
    return {
        wrongPage: cloneDeep(state.wrongPage),
    };
}

export default connect(mapStateToProps)(MainContainer);
